import * as serviceWorker from "./serviceWorker";
import { LDApp } from "./App";
import { Config } from "./Config";
import { createRoot } from "react-dom/client";
import React from "react";
import * as Sentry from "@sentry/react";
import { useLocation, useNavigationType, createRoutesFromChildren, matchRoutes } from "react-router-dom";

// Only enable Sentry in production
if (import.meta.env.VITE_ENV === "prod") {
  Sentry.init({
    dsn: Config.sentryDsn,
    ignoreErrors: ["Non-Error promise rejection captured", "ResizeObserver loop"],
    integrations: [
      Sentry.reactRouterV6BrowserTracingIntegration({
        useEffect: React.useEffect,
        useLocation,
        useNavigationType,
        createRoutesFromChildren,
        matchRoutes,
      }),
      Sentry.captureConsoleIntegration({
        levels: ["error"],
      }),
      Sentry.replayIntegration(),
    ],

    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: !Number.isNaN(parseFloat(Config.sentrySampleRate))
      ? parseFloat(Config.sentrySampleRate)
      : undefined,
    replaysSessionSampleRate: 0.1, // 10%
    replaysOnErrorSampleRate: 1.0, // 100% when sampling sessions where errors occur.
  });
}

const container = document.getElementById("root");
const root = createRoot(container!);
root.render(<LDApp />);

serviceWorker.unregister();
